(function () {
  'use strict';

  /* Mobile menu */
  var menuBtn = document.getElementById('menu-btn');
  var menu = document.getElementById('mobile-menu');
  if (menuBtn && menu) {
    var openMenu = function () {
      menu.classList.add('open');
      menu.setAttribute('aria-hidden', 'false');
      menuBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    var closeMenu = function () {
      menu.classList.remove('open');
      menu.setAttribute('aria-hidden', 'true');
      menuBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };
    menuBtn.addEventListener('click', openMenu);
    menu.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', closeMenu);
    });
    menu.querySelectorAll('nav a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
  }

  /* Tabs: Mais Vendidos / Todos */
  var grids = {
    'mais-vendidos': document.getElementById('grid-mais-vendidos'),
    'todos': document.getElementById('grid-todos')
  };
  var tabButtons = document.querySelectorAll('[data-tab-btn]');
  var sectionTitle = document.getElementById('section-title');
  function setTab(tab) {
    if (!grids[tab]) tab = 'mais-vendidos';
    Object.keys(grids).forEach(function (k) {
      if (grids[k]) grids[k].classList.toggle('hidden', k !== tab);
    });
    tabButtons.forEach(function (b) {
      var on = b.getAttribute('data-tab-btn') === tab;
      b.classList.toggle('active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (sectionTitle) sectionTitle.textContent = tab === 'todos' ? 'Todos os Produtos' : 'Mais Vendidos';
  }
  tabButtons.forEach(function (b) {
    b.addEventListener('click', function () {
      var tab = b.getAttribute('data-tab-btn');
      setTab(tab);
      var url = new URL(window.location.href);
      url.searchParams.set('tab', tab);
      window.history.replaceState({}, '', url);
    });
  });
  var initialTab = new URLSearchParams(window.location.search).get('tab');
  if (initialTab) setTab(initialTab);

  /* Product gallery */
  var mainImage = document.getElementById('main-image');
  var thumbs = Array.from(document.querySelectorAll('[data-thumb-src]'));
  function setImage(src, alt) {
    if (!mainImage || !src) return;
    mainImage.src = src;
    if (alt) mainImage.alt = alt;
    thumbs.forEach(function(t) { t.classList.toggle('active', t.getAttribute('data-thumb-src') === src); });
  }
  thumbs.forEach(function(t) { t.addEventListener('click', function() { setImage(t.getAttribute('data-thumb-src'), t.getAttribute('data-thumb-alt')); }); });
  var dialog = document.getElementById('gallery-dialog');
  var opener = document.getElementById('gallery-open');
  if (dialog && opener && mainImage) {
    opener.addEventListener('click', function() { var zoom = document.getElementById('zoom-image'); if (zoom) { zoom.src = mainImage.src; zoom.alt = mainImage.alt; } dialog.showModal(); });
    dialog.querySelector('.gallery-close').addEventListener('click', function() { dialog.close(); });
    dialog.addEventListener('click', function(e) { if (e.target === dialog) dialog.close(); });
  }

  /* Native variant input is retained for Shopify and Vega. */
  var variantSelect = document.getElementById('variant-select');
  var variants = window.PRODUCT_VARIANTS || [];
  var picker = document.getElementById('option-picker');
  var groups = picker ? Array.from(picker.querySelectorAll('[data-option-index]')) : [];
  var selected = [];
  var current = variants.find(function(v) { return variantSelect && String(v.id) === variantSelect.value; });
  if (current) selected = current.options.slice();
  function money(cents) { return new Intl.NumberFormat('pt-BR', {style:'currency',currency:'BRL'}).format(cents / 100); }
  function applyVariant(v) {
    var status = document.getElementById('variant-status');
    var available = Boolean(v && v.available);
    ['add-to-cart-button','buy-now-button'].forEach(function(id) { var b = document.getElementById(id); if (b) b.disabled = !available; });
    if (status) { status.hidden = available; status.textContent = v ? 'Esta opção está esgotada.' : 'Esta combinação não está disponível.'; }
    if (!v) { if (variantSelect) variantSelect.value = ''; return; }
    if (variantSelect) variantSelect.value = String(v.id);
    var price = document.getElementById('price'), inst = document.getElementById('installment');
    if (price) price.textContent = money(v.price);
    if (inst) inst.textContent = money(v.price / 12);
    var cmp = document.getElementById('price-compare'), off = document.getElementById('price-off');
    var sale = v.compare_at_price > v.price;
    if (cmp) { cmp.hidden = !sale; if (sale) cmp.textContent = money(v.compare_at_price); }
    if (off) { off.hidden = !sale; if (sale) off.textContent = Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)+'% Off'; }
    if (v.featured_image && v.featured_image.src) setImage(v.featured_image.src, v.featured_image.alt);
    var url = new URL(window.location.href); url.searchParams.set('variant',v.id); window.history.replaceState({},'',url);
  }
  function refreshOptions() {
    groups.forEach(function(group,index) {
      var label = group.querySelector('[data-option-current]'); if (label) label.textContent = selected[index] || '';
      group.querySelectorAll('[data-option-value]').forEach(function(b) {
        var value = b.getAttribute('data-option-value');
        var active = value === selected[index];
        b.classList.toggle('selected',active); b.setAttribute('aria-pressed',String(active));
        var possible = variants.some(function(v) { return v.available && v.options.every(function(o,i) { return i === index ? o === value : i > index || o === selected[i]; }); });
        b.classList.toggle('unavailable', !possible);
      });
    });
  }
  if (variantSelect && variants.length) {
    if (picker && current) {
      picker.hidden = false;
      var fallback = document.querySelector('.variant-fallback'); if (fallback) fallback.hidden = true;
      groups.forEach(function(group,index) { group.querySelectorAll('[data-option-value]').forEach(function(b) {
        b.addEventListener('click',function() {
          selected[index] = b.getAttribute('data-option-value');
          var match = variants.find(function(v) { return v.options.every(function(o,i) { return o === selected[i]; }); });
          if (!match || !match.available) {
            var alternate = variants.find(function(v) { return v.available && v.options.every(function(o,i) { return i <= index ? o === selected[i] : true; }); });
            if (alternate) { match = alternate; selected = alternate.options.slice(); }
          }
          applyVariant(match); refreshOptions();
          variantSelect.dispatchEvent(new Event('change',{bubbles:true}));
        });
      }); });
      refreshOptions();
    }
    variantSelect.addEventListener('change',function() { var v = variants.find(function(x) { return String(x.id) === variantSelect.value; }); if (v) { selected = v.options.slice(); applyVariant(v); refreshOptions(); } });
    applyVariant(current);
  }
  var quantity = document.getElementById('quantity');
  document.querySelectorAll('[data-quantity-change]').forEach(function(b) { b.addEventListener('click',function() { if (quantity) { quantity.value = Math.max(1,(parseInt(quantity.value,10)||1)+Number(b.getAttribute('data-quantity-change'))); quantity.dispatchEvent(new Event('change',{bubbles:true})); } }); });
  if (quantity) quantity.addEventListener('change',function() { quantity.value = Math.max(1,parseInt(quantity.value,10)||1); });

  /* Cart: auto refresh on quantity change */
  var cartForm = document.querySelector('form[action*="/cart"]');
  if (cartForm) {
    cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      input.addEventListener('change', function () { cartForm.submit(); });
    });
  }
})();
